import { render } from "./QuotePrice.vue?vue&type=template&id=612cb52c&scoped=true"
import script from "./QuotePrice.vue?vue&type=script&lang=js"
export * from "./QuotePrice.vue?vue&type=script&lang=js"

import "../style.scss?vue&type=style&index=0&id=612cb52c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-612cb52c"]])

export default __exports__